import GA4React from "ga-4-react";
import compliance from "../../assets/img/banner-programa-de-compliance-01.png";
import TrabalheConoscoBanner from "../../assets/img/banner-trabalhe-consco.png";
import historia from "../../assets/img/historia/banner.png";
import NossaPraticas from "../../assets/img/imagem-001.jpg";
import missao from "../../assets/img/missao/banner.jpg";
import { default as FotoDestaqueA, default as FotoDestaqueB, default as FotoDestaqueTaesa } from "../../assets/img/planos/foto-destaque-b-descicao.png";
import FotoDestaque from "../../assets/img/planos/foto-destaque.png";
import vivermelhor from "../../assets/img/vivermelhor/banner.png";
import api from "../Services/api";
import { useEffect, useState } from "react";

const BannerSingle = (props: any) => {

    var BackgroundArray = [
        { "name": "Historia", "img": historia },
        { "name": "missao", "img": missao },
        { "name": "plano-b", "img": FotoDestaqueB },
        { "name": "plano-a", "img": FotoDestaque },
        { "name": "plano-taesaprev", "img": FotoDestaqueTaesa },
        { "name": "plano-a-regulamento", "img": FotoDestaqueA },
        { "name": "plano-b-regulamento", "img": FotoDestaqueA },
        { "name": "plano-taesaprev-cartilha", "img": FotoDestaqueA },
        { "name": "plano-taesaprev-regulamento", "img": FotoDestaqueA },
        { "name": "investimentos-por-indexador", "img": FotoDestaqueA },
        { "name": "plano-b-cartilha", "img": FotoDestaqueA },
        { "name": "plano-a-rentabilidades", "img": FotoDestaqueB },
        { "name": "plano-a-rentabilidades", "img": FotoDestaqueB },
        { "name": "plano-b-rentabilidades", "img": FotoDestaqueB },
        { "name": "plano-taesaprev-rentabilidades", "img": FotoDestaqueB },
        { "name": "trabalhe-conosco", "img": TrabalheConoscoBanner },
        { "name": "atracao-e-selecao", "img": TrabalheConoscoBanner },
        { "name": "nossas-praticas", "img": NossaPraticas },
        { "name": "viver-melhor", "img": vivermelhor },
        { "name": "programa-de-compliance", "img": compliance }
    ];

    var Background: any[] = BackgroundArray.filter(function (Background) {
        return Background.name === props.image;
    });

    // valor default se nao encontrar o item na colecao BackgroundArray
    if (!Background || Background.length === 0) {
        Background.push({ "name": props.image, "img": "" });
    }

    const [_items, setItems] = useState<any[]>([]);

    const [isloaded, setLoaded] = useState(false)
    const { REACT_APP_GOOGLE_GA_TAG } = process.env; 

    useEffect(() => {

        if (!props.items) {

            console.log('✌️ isloaded --->', isloaded);

            setLoaded(true);

            api.get("/ObterLayoutPaginaFiltro?v=1&Identificador=" + props.page)
                .then((response) => {

                    //somente para o mock
                    var result = response.data.results.filter(function (r: any) { return r?.Identificador.toUpperCase() === props.page.toUpperCase(); });

                    setItems(result);

                    try {

                        const ga4react = new GA4React(
                            REACT_APP_GOOGLE_GA_TAG ?? 'G-R0BM8HM4F8',
                            { /* ga custom config, optional */ },
                            [ /* additional code, optional */],
                            3000 /* timeout, optional, defaults is 5000 */,
                            /* { nonce: ['first-script-is-async','second-script'] } */
                        );
                        ga4react.initialize().then((ga4) => {
                            ga4.pageview(window.location.pathname + window.location.search, undefined, decodeURIComponent(document.title));
                        }, (err) => {
                            console.error(err)
                        })
                    } catch (err) {
                        console.error(err);
                    }
                })
                .catch((err) => {
                    throw new Error(err);
                });
        }
        else {
            setItems(props.items);
        }
    }, [props.items]);

    useEffect(() => {
        if (_items.length > 0) {
            document.title = _items[0]?.Title;
        }
    }, [_items]);

    return (

        <section className={`page-banner text-white position-relative ${Background[0]?.img === '' ? "bg-laranja small" : ""}`}
            style={Background[0]?.img !== '' ? { backgroundImage: `url(${Background[0]?.img})` } : {}}>

            <div className={`${Background[0]?.img !== '' ? "" : ""}`}></div>
            {_items?.map((item: any, index: number) => (
                <span key={index}>
                    {item?.URLBanner && <a href={item?.URLBanner?.Url} target="_blank" rel="noreferrer" className="link-banner">
                        <span key="{item.Id}" data-value="{Background[0]?.img}">
                            {Background[0]?.img &&
                                <div className="overlay"></div>
                            }
                            <div className='container h-100'>
                                <div className='row h-100 align-items-center'>
                                    <div className='col-md-8 col-lg-10 mt-lg-10'>
                                        <h2> {item?.Title} </h2>
                                        <div className="text">
                                            <h4>{item?.Descricao} </h4>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </span>  </a>}


                    {!item?.URLBanner &&
                        <span key="{item.Id}" data-value="{Background[0]?.img}">
                            {Background[0]?.img &&
                                <div className="overlay"></div>
                            }

                            <div className='container h-100'>
                                <div className='row h-100 align-items-center'>
                                    <div className='col-md-8 col-lg-10 mt-lg-10'>
                                        <h2> {item?.Title} </h2>
                                        <div className="text">
                                            <h4>{item?.Descricao} </h4>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </span>}
                </span>
            ))
            }
        </section >
    )
};

export default BannerSingle;